import cx from 'classnames'

const SchoolRatingsLevelLink = ({ level, isActive, isDisabled, onClick }) => {
  const classNames = cx('recycledLinks-item', { is__active: isActive, is__disabled: isDisabled })

  return <span className={ classNames } onClick={ onClick }>{ I18n.t('schoolRating.level', { level }) }</span>
}

export default SchoolRatingsLevelLink
